import { type InsuranceCorporateIdentity } from "../types";

export function BKKEuregioLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_30_487)">
        <g clipPath="url(#clip1_30_487)">
          <path d="M640 144H-8V376H640V144Z" fill="#313A8C" />
          <path
            d="M275.822 173.255H640V169.595H275.822V173.255Z"
            fill="#FFC432"
          />
          <path
            d="M171.136 197.052L141.309 167.143H81.6289L111.683 197.052L141.523 226.962H201.19L171.136 197.052Z"
            fill="#FFC432"
          />
          <path
            d="M238.16 197.052L204.002 231.518V250.586V259.909V268.793V291.341L226.267 268.793L235.134 259.909L244.429 250.586L263.677 231.084V197.052V171.261L238.16 197.052Z"
            fill="#FFC432"
          />
          <path
            d="M144.548 292.317V351.488H204.22V292.317H144.548Z"
            fill="#FFC432"
          />
          <path
            d="M198.332 243.746C198.332 244.605 198.123 245.395 197.695 246.127C197.271 246.864 196.696 247.44 195.962 247.865C195.231 248.29 194.442 248.5 193.595 248.5C192.751 248.5 191.958 248.29 191.228 247.865C190.494 247.44 189.919 246.864 189.495 246.127C189.067 245.395 188.857 244.605 188.857 243.746C188.857 242.901 189.067 242.106 189.495 241.374C189.919 240.633 190.494 240.061 191.228 239.632C191.958 239.211 192.751 239.001 193.595 239.001C194.442 239.001 195.231 239.211 195.962 239.632C196.696 240.061 197.271 240.633 197.695 241.374C198.123 242.106 198.332 242.901 198.332 243.746ZM197.409 243.746C197.409 242.691 197.036 241.786 196.285 241.037C195.542 240.289 194.64 239.91 193.586 239.91C192.537 239.91 191.631 240.288 190.888 241.037C190.145 241.786 189.768 242.691 189.768 243.746C189.768 244.807 190.145 245.715 190.888 246.464C191.631 247.213 192.537 247.587 193.586 247.587C194.64 247.587 195.542 247.213 196.285 246.464C197.036 245.715 197.409 244.807 197.409 243.746ZM191.442 241.21H193.708C194.35 241.21 194.816 241.336 195.101 241.597C195.391 241.853 195.533 242.198 195.533 242.636C195.533 242.972 195.424 243.267 195.206 243.511C194.984 243.763 194.635 243.94 194.161 244.049C194.358 244.125 194.501 244.209 194.589 244.292C194.719 244.41 194.854 244.583 194.996 244.814C195.004 244.823 195.277 245.319 195.814 246.286H194.325C193.842 245.319 193.515 244.738 193.351 244.545C193.183 244.356 193.02 244.259 192.856 244.259C192.821 244.259 192.768 244.265 192.701 244.287V246.289H191.442V241.211M192.701 243.336H193.246C193.611 243.336 193.867 243.277 194.018 243.164C194.165 243.05 194.241 242.898 194.241 242.713C194.241 242.528 194.17 242.377 194.027 242.268C193.884 242.149 193.641 242.091 193.297 242.091H192.701L192.701 243.336Z"
            fill="white"
          />
          <path
            d="M64.7451 282.473V238.597H80.9974C88.7752 238.597 93.9996 241.626 93.9996 250.002C93.9996 253.96 92.7219 257.161 89.1823 258.966V259.08C95.4495 259.896 98.1204 264.145 98.1204 270.253C98.1204 279.449 90.2838 282.473 82.2731 282.473L64.7451 282.473ZM76.1213 255.824H77.3991C80.4162 255.824 83.5508 255.298 83.5508 251.575C83.5508 247.558 80.0091 247.327 76.9333 247.327H76.1213V255.824ZM76.1213 273.744H77.5732C80.9386 273.744 86.6267 273.921 86.6267 269.092C86.6267 263.796 80.9974 264.317 77.2816 264.317H76.1213V273.744Z"
            fill="white"
          />
          <path
            d="M129.291 238.597H143.394L125.982 259.37L144.962 282.473H130.218L115.533 263.446H115.418V282.473H104.039V238.597H115.418V256.695H115.533L129.291 238.597Z"
            fill="white"
          />
          <path
            d="M173.289 238.597H187.393L169.98 259.37L188.96 282.473H174.216L159.531 263.446H159.416V282.473H148.038V238.597H159.416V256.695H159.531L173.289 238.597Z"
            fill="white"
          />
          <path
            d="M241.32 317.199V324.527H254.148V334.19H241.32V341.749H254.844V351.408H229.943V307.536H254.844V317.199H241.32Z"
            fill="white"
          />
          <path
            d="M299.829 307.536V332.209C299.829 337.854 299.598 343.44 295.246 347.689C291.587 351.294 285.842 352.577 280.731 352.577C275.624 352.577 269.875 351.294 266.22 347.689C261.865 343.44 261.634 337.854 261.634 332.209V307.536H273.01V330.635C273.01 336.339 273.417 342.565 280.731 342.565C288.045 342.565 288.448 336.339 288.448 330.635V307.536H299.829Z"
            fill="white"
          />
          <path
            d="M343.42 351.408H329.253L318.519 334.535H318.405V351.408H307.029V307.536H324.033C332.681 307.536 339.24 311.672 339.24 321.036C339.24 327.085 335.871 332.326 329.664 333.428L343.42 351.408ZM318.405 327.203H319.505C323.219 327.203 327.398 326.504 327.398 321.734C327.398 316.964 323.219 316.265 319.505 316.265H318.405V327.203Z"
            fill="white"
          />
          <path
            d="M357.872 317.199V324.527H370.7V334.19H357.872V341.749H371.401V351.408H346.492V307.536H371.401V317.199H357.872Z"
            fill="white"
          />
          <path
            d="M422.076 326.917C421.958 333.315 421.488 338.779 417.602 344.256C413.305 350.247 406.864 352.863 399.55 352.863C385.794 352.863 376.214 343.499 376.214 329.71C376.214 315.449 385.849 306.085 399.957 306.085C408.954 306.085 415.915 310.157 419.692 318.36L408.895 322.903C407.326 318.709 404.015 315.912 399.432 315.912C391.946 315.912 388.056 323.072 388.056 329.76C388.056 336.575 392.118 343.499 399.609 343.499C404.539 343.499 408.312 340.933 408.777 335.873H399.491V326.917H422.076Z"
            fill="white"
          />
          <path
            d="M438.676 351.408H427.296V307.536H438.676V351.408Z"
            fill="white"
          />
          <path
            d="M492.305 328.658C492.305 342.86 482.15 352.863 468.101 352.863C454.051 352.863 443.896 342.86 443.896 328.658C443.896 315.39 455.503 306.085 468.101 306.085C480.698 306.085 492.305 315.39 492.305 328.658ZM455.734 328.717C455.734 336.281 461.307 341.808 468.101 341.808C474.89 341.808 480.463 336.281 480.463 328.717C480.463 322.668 474.89 317.136 468.101 317.136C461.307 317.136 455.734 322.668 455.734 328.717Z"
            fill="white"
          />
          <path
            d="M59.1409 296.397L48.6376 295.859L45.9057 285.603L42.1081 295.539L31.5837 294.925L39.7875 301.571L35.9773 311.415L44.8819 305.66L52.9849 312.366L50.2657 302.16L59.1409 296.397Z"
            fill="#FFC432"
          />
          <path
            d="M86.3834 326.508L75.88 325.97L73.1482 315.714L69.3464 325.65L58.8304 325.036L67.03 331.683L63.2198 341.539L72.1244 335.772L80.2274 342.494L77.5082 332.267L86.3834 326.508Z"
            fill="#FFC432"
          />
          <path
            d="M127.805 336.377L117.298 335.843L114.57 325.575L110.764 335.519L100.248 334.901L108.448 341.547L104.637 351.412L113.546 345.64L121.649 352.354L118.926 342.14L127.805 336.377Z"
            fill="#FFC432"
          />
          <path
            d="M48.734 253.948L40.0141 259.854L42.9641 270.051L34.5883 263.505L25.9019 269.479L29.4939 259.542L21.1559 253.077L31.7515 253.401L35.2261 243.456L38.1677 253.615L48.734 253.948Z"
            fill="#FFC432"
          />
          <path
            d="M59.1535 211.801L50.4335 217.707L53.3878 227.904L45.0076 221.358L36.3171 227.332L39.9175 217.396L31.5753 210.926L42.1668 211.254L45.6455 201.301L48.5871 211.465L59.1535 211.801Z"
            fill="#FFC432"
          />
          <path
            d="M86.396 181.85L77.676 187.756L80.6302 197.953L72.246 191.407L63.5597 197.389L67.1601 187.444L58.8179 180.983L69.4135 181.303L72.8923 171.358L75.8339 181.521L86.396 181.85Z"
            fill="#FFC432"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_30_487">
          <rect width="512" height="512" fill="white" />
        </clipPath>
        <clipPath id="clip1_30_487">
          <rect
            width="648"
            height="232"
            fill="white"
            transform="translate(-8 144)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const BKKEuregio: InsuranceCorporateIdentity = {
  id: "bkk-euregio",
  name: "BKK Euregio",
  logo: BKKEuregioLogo,
  backgroundColor: "#313A8C",
  textColor: "#FFFFFF",
  wildcard: "bkk euregio",
  type: "statutory",
};
